import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-popup__content" }

import { onBeforeUnmount, watch } from "vue";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { useStackedModals } from "@sazka/utils/composables/use-stacked-modals";


export default /*@__PURE__*/_defineComponent({
  __name: 'modal-popup',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const closeModalInternal = () => emit("update:modelValue", false);

const keyDownEventHandler = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
        closeModalInternal();
    }
};

const { addToStackedModals, removeFromStackedModals } = useStackedModals();
const modalIsClosing = () => {
    removeFromStackedModals();
    window.removeEventListener("keydown", keyDownEventHandler);
};

const modalIsOpening = () => {
    addToStackedModals();
    window.addEventListener("keydown", keyDownEventHandler);
};

watch(
    () => props.modelValue,
    (newModelValue, oldModelValue) => {
        if (newModelValue && !oldModelValue) {
            modalIsOpening();
        } else if (!newModelValue && oldModelValue) {
            modalIsClosing();
        }
    },
    { immediate: true }
);

onBeforeUnmount(() => {
    if (props.modelValue) {
        modalIsClosing();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(TransitionFade, null, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", _mergeProps({
              key: 0,
              class: "modal-popup"
            }, _ctx.$attrs), [
              _createElementVNode("div", {
                class: "modal-popup__background",
                onClick: closeModalInternal
              }),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", {
                  class: "modal-popup__close",
                  onClick: closeModalInternal
                }),
                _renderSlot(_ctx.$slots, "default")
              ])
            ], 16))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})